import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { makeGetBasketUnavailableProductsState } from '../../../../redux/basket/selectors/BasketSelector';
export const UnavailableProductsMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const hasUnavailableProducts = useSelector(makeGetBasketUnavailableProductsState());
    if (!hasUnavailableProducts)
        return null;
    return _jsx(Banner, { status: "error", text: t(`${I18N_NAMESPACES.checkout}:basket.hasUnavailableProducts`) });
};
